interface VuesticFormErrors {
  [field: string]: string[]
}

function convertErrorDetailsToVuesticFormErrors(errors: any[]): VuesticFormErrors {
  const formErrors: VuesticFormErrors = {}

  errors.forEach((errorItem) => {
    if (errorItem?.source?.pointer?.startsWith('/attachments/')) {
      const fieldName = 'attachments' // Map all attachment errors to the 'attachments' field
      const detail = errorItem.detail ?? 'An attachment error occurred.'

      if (formErrors[fieldName]) {
        formErrors[fieldName].push(detail)
      } else {
        formErrors[fieldName] = [detail]
      }
    } else if (errorItem?.source?.pointer) {
      // Handle other pointer-based errors
      const pointer = errorItem.source.pointer
      const fieldName = pointer.substring(1).replace(/\//g, '.')
      const detail = errorItem.detail ?? 'An error occurred.'

      if (formErrors[fieldName]) {
        formErrors[fieldName].push(detail)
      } else {
        formErrors[fieldName] = [detail]
      }
    } else {
      // Handle general errors
      const generalField = '__general'
      const detail = errorItem.detail ?? 'A general error occurred.'
      if (formErrors[generalField]) {
        formErrors[generalField].push(detail)
      } else {
        formErrors[generalField] = [detail]
      }
    }
  })

  return formErrors
}

const devDebug = (...args: any[]) => {
  if (import.meta.env.DEV) {
    const stack = new Error().stack
    const match = stack?.split('\n')[2]?.match(/at\s+.+\s+\((.+):(\d+):(\d+)\)/)
    const file = match?.[1]?.split('/').pop() ?? ''
    const line = match?.[2] ?? ''
    const location = file && line ? `[${file}:${line}]` : ''
    console.debug(
      location,
      ...args.map((arg) => (typeof arg === 'object' && arg !== null ? JSON.stringify(arg, null, 2) : arg)),
    )
  }
}

export { convertErrorDetailsToVuesticFormErrors, VuesticFormErrors, devDebug }
